class AnimatedLogo extends HTMLElement {
  constructor() {
    super();
    // Get the data attributes
    this.shouldAnimateOpacity = this.dataset.animateOpacity == 'true';
    this.shouldAnimateScale = this.dataset.animateScale == 'true';

    // Get the height of the header
    this.headerHeight = document.querySelector('.header').offsetHeight;
    // Set the speed at which the logo scales
    this.scaleSpeed = 1.5;
    // Set the speed at which the logo fades out
    this.opacitySpeed = this.shouldAnimateScale ? 2 : 1;
    // Set the position at which the header logo swaps
    this.headerSwapPosition = this.shouldAnimateScale ? 0.5 : 1;
    // Get the logo element
    this.logo = this.querySelector('.logo .icon');
    // Get the header logo svg elements
    this.headerLogoWordmark = document.querySelector('.header .icon-antler-wordmark');
    this.headerlogoIcon = document.querySelector('.header .icon-antler-logo');
  }

  connectedCallback() {
    // attach event listener to window scroll event
    window.addEventListener("scroll", this.calculateScrollProgress.bind(this));

    this.initialHeaderLogoSwap()
  }


  calculateScrollProgress() {
      // Get the total height of the page inner height minus the header height
      const totalHeight = window.innerHeight - this.headerHeight;
      // Get the current scroll position
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // Calculate the scroll progress based on the current scroll position and the total height
      const scrollProgress = scrollTop / totalHeight;
      // Ensure the scrollProgress value is within the [0, 1] range
      const position = Math.min(Math.max(scrollProgress, 0), 1).toFixed(3);
      // Update the logo's opacity and scale
      if(this.shouldAnimateOpacity) this.handleOpacity(position);
      if(this.shouldAnimateScale) this.handleScale(position);
      // Update the header logo
      this.handleHeaderLogoSwap(position);
  }

  handleOpacity(position) {
    requestAnimationFrame(() => {
      // Invert position value so that the opacity starts at 1 and ends at 0, also times it by the opacity speed
      const opacity = 1 - position * this.opacitySpeed;
      // Apply the opacity value to the logo
      this.logo.style.opacity = opacity;
    });
  }

  handleScale(position) {
    requestAnimationFrame(() => {
      // Invert position value so that the scale starts at 1 and ends at 0, also times it by the scale speed
      const scale = 1 - position * this.scaleSpeed;
      // Apply the scale value to the logo
      this.logo.style.transform = `scale(${scale})`;
    });
  }

  initialHeaderLogoSwap() {
    if(window.pageYOffset > 0 || document.documentElement.scrollTop > 0) {
      this.headerlogoIcon.classList.add('logo-hidden')
      this.headerLogoWordmark.classList.add('show')
    }
    this.headerLogoWordmark.classList.add('transition')
    this.headerlogoIcon.classList.add('transition')
  }

  handleHeaderLogoSwap(position) {
    // If the scroll position is greater than the headerSwapPosition, swap the header logo
    if (position >= this.headerSwapPosition) {
      this.headerlogoIcon.classList.add('logo-hidden')
      this.headerlogoIcon.classList.remove('transition-delay')
      this.headerLogoWordmark.classList.add('show')
      this.headerLogoWordmark.classList.add('transition-delay')
    } else {
      this.headerLogoWordmark.classList.remove('show')
      this.headerLogoWordmark.classList.remove('transition-delay')
      this.headerlogoIcon.classList.add('transition-delay')
      this.headerlogoIcon.classList.remove('logo-hidden')
    }
  }
}

customElements.define("animated-logo", AnimatedLogo);